/*
 *
 * File JS componente fixed ticket button
 *
 */

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import "./fixed-ticket-button.scss";

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const fixedTicketButton = () => {
    let fixedTicketButton = document.querySelector(".fixed-ticket-button");
    if (!fixedTicketButton) return;

    const observer = new IntersectionObserver(
        ([fixedTicketButton]) =>
            fixedTicketButton.target.classList.toggle(
                "is-unpinned",
                fixedTicketButton.intersectionRatio < 1
            ),
        { threshold: [1] }
    );

    observer.observe(fixedTicketButton);
};

export default fixedTicketButton;

//--------------------------------------------------------------------//
